import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_ROUTES as SETTINGS } from "@/Generated/Routes/paths";

import subscriptions from "./Subscriptions";
import questionnaires from "./Questionnaires";
import account from "./Account";
import help from "./Help";
import configuration from "./Configuration";
import legalAgreementsRoutes from "./LegalAgreements";
import invoices from "./Invoices";
import patientReferral from "./PatientReferral";
import payments from "./PaymentReceipts";

import { buildBeforeEnterChain, initWSGuard, isTherapistGuard } from "@/Router/guards";

const settings: RouteRecordRaw = {
  path: SETTINGS.root.path,
  component: () => import("@/Components/layout/MainLayout.vue"),
  beforeEnter: buildBeforeEnterChain(initWSGuard),
  children: [
    {
      path: SETTINGS.root.path,
      components: {
        sidebar: () => import("@/Components/layout/SidebarLayout.vue"),
        main: () => import("@/Views/MainLanding.vue"),
      },
      meta: {
        sidebar: true,
        drawer: false,
      },
      children: [
        {
          ...SETTINGS.root,
          component: () => import("@/Views/settings/index.vue"),
          meta: {
            noHeader: true,
          },
        },

        {
          ...SETTINGS.subscriptions.root,
          meta: {
            i18nTitle: "settings.subscriptions-title",
          },
          component: () => import("@/Views/settings/subscription/Subscription.vue"),
        },
        {
          ...SETTINGS.loyaltyPlan.root,
          meta: {
            i18nTitle: "settings.loyalty_plan",
          },
          component: () => import("@/Views/settings/objectives/LoyaltyPlan.vue"),
          beforeEnter: buildBeforeEnterChain(isTherapistGuard),
        },
        {
          ...SETTINGS.privacy.root,
          meta: {
            i18nTitle: "settings.privacy.title",
          },
          component: () => import("@/Views/settings/privacy/index.vue"),
        },
        ...account,
        ...subscriptions,
        ...questionnaires,
        ...help,
        ...configuration,
        ...legalAgreementsRoutes,
        ...invoices,
        ...payments,
        ...patientReferral,
      ],
    },
  ],
};
export default settings;
